import Calc from "@/common/util/calculator"
import Form from "./base"
import PathObject from "../objects/path"
import pathRounding from "@/signomatic/util/path_rounding"
import type { DrawableMixin } from "../objects/drawable_mixin"

export default class ArchedTop extends Form {
  protected path(width: number, height: number, rounding?: number) {
    const [side, rest] = this.snappableCommands(width, height)
    rest.shift()
    const cmds = side.concat(rest)

    cmds.push(this.pathClose())

    let path = cmds.join(" ")

    if (rounding) {
      path = pathRounding(path, rounding).join(" ")
    }

    return new PathObject(path, this.defaultParams)
  }

  protected snappablePaths(width: number, height: number): [DrawableMixin, DrawableMixin] {
    const [side, rest] = this.snappableCommands(width, height)

    return [new PathObject(side.join(""), this.defaultParams), new PathObject(rest.join(""), this.defaultParams)]
  }

  private snappableCommands(width: number, height: number): [string[], string[]] {
    const arcH = height * 0.35
    const aw = width * 0.22
    const curveExt = Calc.mmToPx(1)

    const side = [this.pathMoveTo(-(width / 2), height / 2)]
    side.push(this.pathLineToAbs(-(width / 2), -(height / 2) + arcH))

    const rest = [this.pathMoveTo(-(width / 2), -(height / 2) + arcH)] // UL

    rest.push(this.pathLineToAbs(-(width / 2) + aw, -(height / 2) + arcH)) // ULM
    rest.push(this.pathLineToAbs(-(width / 2) + aw, -(height / 2) + arcH - curveExt))

    rest.push(this.pathQuadAbs(-(width / 2) + aw, -(height / 2), 0, -(height / 2))) // LC
    rest.push(this.pathQuadAbs(width / 2 - aw, -(height / 2), width / 2 - aw, -(height / 2) + arcH - curveExt)) //RC

    rest.push(this.pathLineToAbs(width / 2 - aw, -(height / 2) + arcH))
    rest.push(this.pathLineToAbs(width / 2, -(height / 2) + arcH)) // UR
    rest.push(this.pathLineToAbs(width / 2, height / 2)) // LR
    rest.push(this.pathLineToAbs(-(width / 2), height / 2)) // LL

    return [side, rest]
  }

  protected get cutlineRounding() {
    return this.printCutlineRounding(this.calcRounding())
  }

  private calcRounding() {
    if (["aluminium_sign", "acryl_sign", "acryl_alu_sign"].includes(this.signType)) {
      return Calc.mmToPx(0.5)
    }

    return 0
  }
}
